module.exports = __webpack_public_path__ + "static/media/logo-위즈돔@2x.b09c8da6.png";